import { render, staticRenderFns } from "./AgentBuyCreditComponent.vue?vue&type=template&id=2e562af9&"
import script from "./AgentBuyCreditComponent.vue?vue&type=script&lang=js&"
export * from "./AgentBuyCreditComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports